import { useCallback, useMemo } from 'react';
import type { GameId } from '../api/types';
import { gameById } from '../data/games';
import { useUserPrefs } from './useUserPrefs';

export function useActiveGame() {
  const { prefs, setPartial } = useUserPrefs();
  const game = gameById(prefs.gameId);
  const setGameId = useCallback(
    (gameId: GameId) => {
      setPartial({ gameId });
    },
    [setPartial]
  );

  return useMemo(
    () => ({
      game,
      gameId: game.id,
      setGameId,
    }),
    [game, setGameId]
  );
}
